import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { SocialProofBar } from '../components/home/SocialProofBar';
import { TodayInSky } from '../components/home/TodayInSky';
import { HowItWorks } from '../components/home/HowItWorks';
import { PopularServices } from '../components/home/PopularServices';
import { WhyAstroGuide } from '../components/home/WhyAstroGuide';
import { PricingSection } from '../components/home/PricingSection';
import { ReportPreviewSection } from '../components/home/ReportPreviewSection';
import { TopAstrologersSection } from '../components/home/TopAstrologersSection';
import { AstroCalendarSection } from '../components/home/AstroCalendarSection';
import { BlogSection } from '../components/home/BlogSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ForAstrologersSection } from '../components/home/ForAstrologersSection';
import { FaqSection } from '../components/home/FaqSection';
import { FinalCtaSection } from '../components/home/FinalCtaSection';
import { SectionErrorBoundary } from '../components/SectionErrorBoundary';
import { AdSlot } from '../components/ads/AdSlot';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="w-full" data-id="element-20476">
      {/* 1. HERO */}
      <SectionErrorBoundary sectionName="HeroBanner" fallbackMinHeight="min-h-screen" data-id="element-20477">
        <HeroBanner onNavigate={onNavigate} data-id="element-20478" />
      </SectionErrorBoundary>

      {/* 2. SOCIAL PROOF BAR */}
      <SectionErrorBoundary sectionName="SocialProofBar" fallbackMinHeight="min-h-[80px]" data-id="element-20479">
        <SocialProofBar data-id="element-20480" />
      </SectionErrorBoundary>

      {/* 3. СЕГОДНЯ В НЕБЕ */}
      <SectionErrorBoundary sectionName="TodayInSky" data-id="element-20481">
        <TodayInSky onNavigate={onNavigate} data-id="element-20482" />
      </SectionErrorBoundary>

      {/* 4. КАК ЭТО РАБОТАЕТ */}
      <SectionErrorBoundary sectionName="HowItWorks" data-id="element-20483">
        <HowItWorks data-id="element-20484" />
      </SectionErrorBoundary>

      {/* 5. ПОПУЛЯРНЫЕ УСЛУГИ */}
      <SectionErrorBoundary sectionName="PopularServices" data-id="element-20485">
        <PopularServices onNavigate={onNavigate} data-id="element-20486" />
      </SectionErrorBoundary>

      {/* 6. ПОЧЕМУ ASTROGUIDE */}
      <SectionErrorBoundary sectionName="WhyAstroGuide" data-id="element-20487">
        <WhyAstroGuide data-id="element-20488" />
      </SectionErrorBoundary>

      {/* 7. ТАРИФЫ */}
      <SectionErrorBoundary sectionName="PricingSection" data-id="element-20489">
        <PricingSection onNavigate={onNavigate} data-id="element-20490" />
      </SectionErrorBoundary>

      {/* 8. ПРЕВЬЮ ОТЧЁТА */}
      <SectionErrorBoundary sectionName="ReportPreviewSection" data-id="element-20491">
        <ReportPreviewSection onNavigate={onNavigate} data-id="element-20492" />
      </SectionErrorBoundary>

      {/* 9. ТОП АСТРОЛОГИ */}
      <SectionErrorBoundary sectionName="TopAstrologersSection" data-id="element-20493">
        <TopAstrologersSection onNavigate={onNavigate} data-id="element-20494" />
      </SectionErrorBoundary>

      {/* 10. КАЛЕНДАРЬ */}
      <SectionErrorBoundary sectionName="AstroCalendarSection" data-id="element-20495">
        <AstroCalendarSection onNavigate={onNavigate} data-id="element-20496" />
      </SectionErrorBoundary>

      {/* 11. БЛОГ */}
      <SectionErrorBoundary sectionName="BlogSection" data-id="element-20497">
        <BlogSection onNavigate={onNavigate} data-id="element-20498" />
      </SectionErrorBoundary>

      {/* 12. ОТЗЫВЫ */}
      <SectionErrorBoundary sectionName="ReviewsSection" data-id="element-20499">
        <ReviewsSection data-id="element-20500" />
      </SectionErrorBoundary>

      {/* Ad Banner after reviews — SLOT-15 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-20501">
        <AdSlot slotId="SLOT-15" onNavigate={onNavigate} data-id="element-20502" />
      </div>

      {/* 13. ДЛЯ АСТРОЛОГОВ */}
      <SectionErrorBoundary sectionName="ForAstrologersSection" data-id="element-20503">
        <ForAstrologersSection onNavigate={onNavigate} data-id="element-20504" />
      </SectionErrorBoundary>

      {/* 14. FAQ */}
      <SectionErrorBoundary sectionName="FaqSection" data-id="element-20505">
        <FaqSection data-id="element-20506" />
      </SectionErrorBoundary>

      {/* 15. ФИНАЛЬНЫЙ CTA */}
      <SectionErrorBoundary sectionName="FinalCtaSection" data-id="element-20507">
        <FinalCtaSection data-id="element-20508" />
      </SectionErrorBoundary>
    </div>;
}